import {computed} from 'vue';

import {useActiveTariff} from "./queries";
import {useSelectedCompany} from "./useSelectedCompany";

/**
 * Активный тариф выбранной компании.
 *
 * Живёт отдельно от queries.ts, чтобы слой запросов оставался листом в графе импортов:
 * useSelectedCompany сам читает useCompaniesQuery.
 */
export const useActiveTariffBySelectedCompany = () => {
    const {selectedCompany} = useSelectedCompany();

    return useActiveTariff(computed(() => selectedCompany.value?.bin));
}
